import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { TimeagoModule } from 'ngx-timeago';
import { ReactiveFormsModule } from '@angular/forms';
import { PermissionService } from '@src/app/_services/permission.service';
import { RouterModule } from '@angular/router';
import { TagInputModule } from 'ngx-chips';
import { ForeignKeyService } from '@syncfusion/ej2-angular-grids';
import {
    ButtonAllModule,
    CheckBoxAllModule,
    RadioButtonAllModule,
    SwitchAllModule,
} from '@syncfusion/ej2-angular-buttons';
import {
    ComboBoxAllModule,
    DropDownListAllModule,
    MultiSelectAllModule,
} from '@syncfusion/ej2-angular-dropdowns';
import {
    DatePickerAllModule,
    DateRangePickerAllModule,
    DateTimePickerAllModule,
    TimePickerAllModule,
} from '@syncfusion/ej2-angular-calendars';
import {
    ContextMenuAllModule,
    SidebarModule,
    TabAllModule,
    ToolbarModule,
} from '@syncfusion/ej2-angular-navigations';
import {
    NumericTextBoxAllModule,
    TextBoxAllModule,
    UploaderAllModule,
} from '@syncfusion/ej2-angular-inputs';
import { DialogModule } from '@syncfusion/ej2-angular-popups';
import {
    DetailsViewService,
    FileManagerAllModule,
    NavigationPaneService,
} from '@syncfusion/ej2-angular-filemanager';
import { CircularGaugeAllModule } from '@syncfusion/ej2-angular-circulargauge';
import {
    FileManagerService,
    ImageService,
    LinkService,
} from '@syncfusion/ej2-angular-richtexteditor';
import { NavHandlerService } from '@src/app/_services/nav-handler.service';
import { DropDownButtonAllModule } from '@syncfusion/ej2-angular-splitbuttons';
import { FileSizePipe } from '@src/app/shared_components/pipes/file-size.pipe';
import { FilterPipe } from '@src/app/shared_components/pipes/filter.pipe';
import { MomentPipe } from '@src/app/shared_components/pipes/moment.pipe';
import { ThreadsPipe } from '@src/app/shared_components/pipes/threads.pipe';
import { TruncateTextPipe } from '@src/app/shared_components/pipes/truncate-text.pipe';
import { UrlencodePipe } from '@src/app/shared_components/pipes/urlencode.pipe';
import { LuxonModule } from 'luxon-angular';
import { HumanizeBytesPipe } from './pipes/humanize-bytes.pipe';
import { FileExtensionPipe } from './pipes/file-extension.pipe';

TagInputModule.withDefaults({
    tagInput: {
        placeholder: 'Přidat nový štítek',
        secondaryPlaceholder: '+ přidat štítek',
    },
    dropdown: {
        showDropdownIfEmpty: true,
        keepOpen: false,
        focusFirstElement: true,
        minimumTextLength: 1,
        limitItemsTo: 20,
        zIndex: 100000,
    },
});

@NgModule({
    imports: [
        ButtonAllModule,
        CheckBoxAllModule,
        CircularGaugeAllModule,
        ComboBoxAllModule,
        TimeagoModule.forRoot(),
        ContextMenuAllModule,
        DatePickerAllModule,
        DateRangePickerAllModule,
        DateTimePickerAllModule,
        DialogModule,
        DropDownButtonAllModule,
        DropDownListAllModule,
        FileManagerAllModule,
        LuxonModule,
        MultiSelectAllModule,
        NumericTextBoxAllModule,
        RadioButtonAllModule,
        ReactiveFormsModule,
        RouterModule,
        SidebarModule,
        SwitchAllModule,
        TabAllModule,
        TextBoxAllModule,
        ToolbarModule,
        UploaderAllModule,
    ],
    declarations: [
        FileExtensionPipe,
        FileSizePipe,
        FilterPipe,
        HumanizeBytesPipe,
        MomentPipe,
        ThreadsPipe,
        TruncateTextPipe,
        UrlencodePipe,
    ],
    exports: [
        ButtonAllModule,
        CheckBoxAllModule,
        CircularGaugeAllModule,
        ComboBoxAllModule,
        ContextMenuAllModule,
        DatePickerAllModule,
        DateRangePickerAllModule,
        DateTimePickerAllModule,
        DialogModule,
        DropDownButtonAllModule,
        DropDownListAllModule,
        FileExtensionPipe,
        FileManagerAllModule,
        FileSizePipe,
        FilterPipe,
        HumanizeBytesPipe,
        LuxonModule,
        MomentPipe,
        MultiSelectAllModule,
        NumericTextBoxAllModule,
        RadioButtonAllModule,
        SidebarModule,
        SwitchAllModule,
        ThreadsPipe,
        TimeagoModule,
        TimePickerAllModule,
        ToolbarModule,
        TruncateTextPipe,
        UploaderAllModule,
        UrlencodePipe,
    ],
    providers: [
        DetailsViewService,
        FileManagerService,
        ForeignKeyService,
        ImageService,
        LinkService,
        NavHandlerService,
        NavigationPaneService,
        PermissionService,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class SharedModule {}
